import bdServices from '../bd-services'
import 'regenerator-runtime'

var FormData = require('form-data')
const currentUrl = window.location.hostname

const FacturaServices = {}

FacturaServices.getFactura = async function(oficina) {
  const data = await bdServices.get(`/servidores/inventario/getFacturas.php?ofi=${oficina}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}
export default FacturaServices


// WEBPACK FOOTER //
// ./src/services/inventario/facturas.js